export interface ApiList<T> {
  total: number;
  data: T[];
}

export interface ApiItem<T> {
  data: T;
  messages: [];
}

export interface IUrlParam {
  key: string;
  value: string;
}

export interface APIConfig {
  appUrl: string;
  authName: string;
}

export interface APIBlob {
  filename: string;
  blob: Blob;
}

export interface ServerError {
  type: number;
  code: string;
  description: string;
}

export class ApiError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  json: Promise<any>;
  response: Response;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(response: Response, json: any) {
    super(response.statusText);
    this.name = "ApiError";
    this.json = json;
    this.response = response;
  }
}
